// Mock data for Ismail Essagar's Data Science Portfolio
export const portfolioData = {
  personal: {
    name: "Ismail Essagar",
    title: "Machine Learning Engineer",
    subtitle: "Data Science & Engineering",
    location: "France",
    experience: "1+ Years Experience",
    email: "essagarismail@gmail.com",
    phone: "+33 7 45 18 72 22",
    linkedin: "linkedin.com/in/ismail-essagar",
    github: "github.com/ismailsg",
    bio: "Artificial intelligence engineer with a Master's degree in Data Science and Engineering. I design and deploy robust and scalable data solutions, from data collection to machine learning. My experience encompasses data engineering, AI model development, Kubernetes orchestration, and cloud deployment."
  },

  skills: {
    categories: [
      {
        name: "Machine Learning",
        technologies: ["Scikit-Learn", "TensorFlow", "PyTorch", "Regression", "Classification", "Clustering", "Random Forest"]
      },
      {
        name: "Deep Learning & NLP",
        technologies: ["CNN", "RNN", "LSTM", "Transformers", "BERT", "HuggingFace", "NLP"]
      },
      {
        name: "Data Engineering",
        technologies: ["Apache Airflow", "Kafka", "Spark", "Hadoop", "Databricks", "Docker", "Kubernetes"]
      },
      {
        name: "Programming",
        technologies: ["Python", "R", "Java", "JavaScript", "SQL"]
      },
      {
        name: "Cloud & DevOps",
        technologies: ["AWS", "GCP", "Docker", "Kubernetes", "Git", "Rancher"]
      },
      {
        name: "Data Visualization",
        technologies: ["Power BI", "Matplotlib", "Seaborn", "Kibana", "Chart.js"]
      },
      {
        name: "Databases",
        technologies: ["MySQL", "PostgreSQL", "MongoDB", "Snowflake", "BigQuery", "ElasticSearch"]
      }
    ]
  },

  experience: [
    {
      id: 1,
      company: "CMA CGM",
      role: "Full Stack Data Scientist",
      period: "September 2024 - Present",
      location: "Marseille, France",
      description: "International data pipeline monitoring and optimization using Python and NodeJS. Built and deployed over 12 dashboards in Power BI and Kibana. Reduced anomalies by 100% through 6 Power BI dashboards. Developed a Random Forest regression model with 99.99% accuracy to predict GPS positions. Used Kafka for real-time processing and Docker to simulate a production environment.",
      technologies: ["Python", "NodeJS", "Power BI", "Docker", "Random Forest", "ElasticSearch", "Kibana"],
achievements: [
  "Ensured reliable data flow across 5+ international terminals with zero recorded loss incidents",
  "Detected and resolved operational anomalies across multiple pipelines",
  "Achieved 99.99% model accuracy during validation phase on real-world test data"
]
    },
    {
      id: 2,
      company: "ONTBO",
      role: "Data Engineer - Emotion Analysis",
      period: "March 2024 - September 2024",
      location: "Compiègne, France",
      description: "Researched emotion datasets using VAD and EKMAN models. Optimized both NLP and computer vision models using Reinforcement Learning. Applied RNNs and CNNs for multimodal emotion detection across text, audio, and image data. Integrated deep learning techniques for enhanced emotion classification performance",
      technologies: ["Python", "NLP", "TensorFlow", "PyTorch", "Keras", "RNN", "CNN"],
      achievements: [
               "Improved emotion classification accuracy across text and image datasets",
               "Built and tested 4 reinforcement learning pipelines for NLP and vision tasks",
               "Successfully combined RNN and CNN architectures for real-time emotion detection",
               "Mastered Unix/Linux production environment"
      ]
    },
    {
      id: 3,
      company: "Technocolabs Softwares",
      role: "Data Scientist - Flight Price Prediction",
      period: "May 2022 - September 2022",
      location: "Remote (India)",
      description: "Designed system to predict flight ticket prices by class. Developed Machine Learning model using Random Forest with hyperparameter optimization achieving 96% accuracy.",
      technologies: ["Python", "Pandas", "Scikit-learn", "Random Forest", "Heroku", "HTML", "CSS", "JavaScript"],
      achievements: [
        "96% accuracy in price predictions",
        "Identified optimal purchase times",
        "Improved fare decision-making process"
      ]
    }
  ],

  projects: [
    {
      id: 1,
      title: "Analytical Pipeline – Energy in France",
      description: "Comprehensive pipeline analyzing French energy mix from public data using Kubernetes orchestration and automated deployment.",
      technologies: ["K3s", "Rancher", "Airflow", "Snowflake", "dbt Cloud", "Python", "ArgoCD"],
      features: [
        "Centralized K8s cluster management with Rancher",
        "Automated deployment with ArgoCD",
        "Medallion architecture (Bronze, Silver, Gold)",
        "Real-time data ingestion from multiple sources"
      ],
      category: "Data Engineering",
      link: "https://github.com/ismailsg/dags_airflow"
    },
    {
      id: 2,
      title: "Leaf Doctor",
      description: "Mobile application using CNN model to detect plant diseases from images with diagnosis suggestions and treatment solutions.",
      technologies: ["Flutter", "Python", "CNN", "TensorFlow"],
      features: [
        "Real-time disease detection",
        "Treatment recommendations",
        "Image capture and analysis",
        "Results sharing and saving"
      ],
      category: "Computer Vision",
      award: "First Prize - Orange AI & ENSAM Competition 2023",
      link: "https://github.com/ismailsg/Leaf-Doctor"
    },
    {
      id: 3,
      title: "NLP Grammar Correction",
      description: "T5 Transformer model for English grammar and spelling correction with high accuracy performance.",
      technologies: ["T5", "Transformers", "NLP", "Python"],
      features: [
        "Grammar error detection",
        "Spelling correction",
        "Context-aware suggestions",
        "Real-time processing"
      ],
      category: "Natural Language Processing",
      link: "https://github.com/ismailsg/Correction_NLP.git"
    },
    {
      id: 4,
      title: "AI Chatbot for Architeo",
      description: "Intelligent chatbot based on RNN to enhance customer interactions with context understanding and personalized responses.",
      technologies: ["RNN", "NLP", "Python", "Deep Learning"],
      features: [
        "Context-aware conversations",
        "Personalized responses",
        "Customer interaction enhancement",
        "Business integration"
      ],
      category: "Conversational AI",
      award: "First Prize - AI&ML Summer Competition 2022",
      link:"https://github.com/ABDELLAH-Hallou/ChatWithArchiteo"
    }
  ],

  education: [
    {
      institution: "University Aix-Marseille",
      degree: "Master’s in Data Science and Engineering",
      period: "2024 - 2025",
      location: "Marseille, France",
      type: "Apprenticeship"
    },
    {
      institution: "UTC Compiègne",
      degree: "IA & Data Science",
      period: "2023 - 2024",
      location: "Compiègne, France",
      type: "University Exchange"
    },
    {
      institution: "ENSAM Casablanca",
      degree: "Engineering Degree in Artificial Intelligence and Computer Engineering",
      period: "2021 - 2023",
      location: "Casablanca, Morocco"
    },
    {
      institution: "EST Agadir",
      degree: "University Diploma of Technology in Computer Engineering",
      period: "2019 - 2021",
      location: "Agadir, Morocco"
    }
  ],

  certifications: [
    "Astronomer: Apache Airflow 3 Fundamentals ",
    "Udacity Nanodegree: Data Analysis (ALX-T)",
    "Udemy: Ultimate Snowflake SnowPro Core Certification",
    "Coursera - Design Thinking for Innovation",
    "Kaggle - Machine Learning Certifications"
  ],

  languages: [
    { name: "Arabic", level: "Native" },
    { name: "French", level: "C2 - Professional" },
    { name: "English", level: "C1 - Advanced" }
  ]
};